import React from 'react';

const InfoWarranty = ({ styleText = '', children} ) => {
    return (
        <div className={`info ${styleText}`}>{children}</div>
    );
};
export default InfoWarranty;
